export default function getLocalizedTime(countryCode: string) {
  // 固定日期：2025年9月1日
  // 注意：月份是 0 索引的，所以 8 代表 9 月
  const date = new Date(2025, 8, 1); // 2025-09-01

  const locale = countryCode || 'en-US';
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'long',
    // timeStyle: 'medium' // 因为是固定日期，通常不需要时间，可以移除
    // 如果需要包含时间，可以加上，但会显示为 00:00:00
  }).format(date);
}